<template>

  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{ errorMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{ successMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
        </div>
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ _.startCase(currentProfile) }}
          </h3>
        </div>
        <div class="col-md-9 text-right">
          <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class=" dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div class="dropdown-item" v-if="accessRights.includes('T')"
                @click.prevent="showActionDrawer('print_list')">
                <i class="fa fa-print"></i>
                <span>Print</span>
              </div>
              <div v-if="serverType == 'ho' && accessRights.includes('I')" class="dropdown-item"
                @click.prevent="showActionDrawer('import_list')">
                <i class="fa fa-upload"></i>
                <span>Import</span>
              </div>
              <div v-if="accessRights.includes('E')" class="dropdown-item"
                @click.prevent="showActionDrawer('export_list')">
                <i class="fa fa-download"></i>
                <span>Export</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                <i class="fa fa-list-ul"></i>
                <span>Customize List</span>
              </div>
            </template>
          </base-dropdown>

          <div v-if="serverType == 'ho'">
            <div v-if="checkedItems.length == 0">
              <base-button v-if="(currentProfile != 'payment_types') && accessRights.includes('A')"
                class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer(0)">+ Add
                {{ _.startCase(_.singularize(currentProfile)) }}</base-button>
            </div>
            <div
              v-else-if="checkedItems.length == 1 && accessRights.includes('W') && (this.$parent.filterStatus == '' || this.$parent.filterStatus == '0')">
              <base-button v-if="this.itemStatus == 'I'" class="float-right ml-1" type="default" size="sm"
                @click.prevent="massupdate('status', 'A')">Activate</base-button>
              <base-button v-if="this.itemStatus == 'A'" class="float-right ml-1" type="default" size="sm"
                @click.prevent="massupdate('status', 'I')">Deactivate</base-button>
              <div class="ml-1"></div>
            </div>

            <div v-else-if="checkedItems.length > 0 && accessRights.includes('W')">
              <base-button v-if="this.$parent.filterStatus != 'A'" class="float-right ml-1" type="default" size="sm"
                @click.prevent="massupdate('status', 'A')">Activate</base-button>
              <base-button v-if="this.$parent.filterStatus != 'I'" class="float-right ml-1" type="default" size="sm"
                @click.prevent="massupdate('status', 'I')">Deactivate</base-button>
              <div class="ml-1"></div>
            </div>
          </div>

        </div>

      </div>

    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
      <div v-if="profileAction == 'customize_list'">
        <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
        <small>Check the fields that you want to see on the list. Drag the fields to
          specify position.</small>
        <br /><br />

        <div class="list-group list-group-item">
          <div class="row">
            <div class="col-md-6"><b>AVAILABLE FIELDS</b></div>
            <div class="col-md-6">
              <a-checkbox class="float-right" @change="onCheckAllField" :checked="
                this.checkedFields.length == this.availableFields.length
              " />
            </div>
          </div>
        </div>

        <draggable :key="draggableKey" :list="availableFields" class="list-group" @start="dragging = true"
          @end="dragging = false">
          <div class="list-group-item draggable"
            :style="index == availableFields.length - 1 ? 'margin-bottom: 50px;' : ''"
            v-for="(element, index) in availableFields" :key="element">
            <div class="row">
              <!-- This _.startCase() will convert any casing into Start Case -->
              <div class="col-md-6">
                {{ _.startCase(element) }}
              </div>
              <div class="col-md-6">
                <a-checkbox class="float-right" @change="onCheckField(element)"
                  :checked="checkedFields.includes(element)" />
              </div>
            </div>
          </div>
        </draggable>

        <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
          <button class="btn btn-primary float-right" @click.prevent="updateTableList">
            Update List
          </button>
        </div>
      </div>

      <div v-if="profileAction == 'export_list'">
        <h6 class="heading-small text-muted mb-4">Export Options</h6>
        <base-alert v-if="errors.length" type="danger">
          <b>You have the following error(s):</b>
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </base-alert>
        <div>
          <a-radio-group v-model="exportSelection">
            <a-radio :style="radioStyle" :value="0">Export All</a-radio>
            <a-radio :style="radioStyle" :value="1">Export Current Page</a-radio>
            <a-radio :style="radioStyle" :value="2">Export Selected</a-radio>
            <a-radio :style="radioStyle" :value="3">Export Filtered</a-radio>
          </a-radio-group>
        </div>
        <div
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-primary float-right" @click.prevent="download">Export</button>
        </div>
      </div>

      <div v-if="profileAction == 'print_list'">
        <h6 class="heading-small text-muted mb-4">Print Options</h6>
      </div>

      <div v-if="profileAction == 'import_list'">
        <import-profile @closeDrawer="closeDrawer"></import-profile>
      </div>
    </a-drawer>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="visible">
      <div>
        <device-form v-if="currentProfile=='devices'" v-on:refreshPage="refreshPage" v-on:displayMessage="displayMessage" :key="componentKey" :locationOptions="locationOptions"></device-form>
        <bagger-form v-if="currentProfile=='baggers'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></bagger-form>
        <bank-card-form v-if="currentProfile=='bank_cards'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></bank-card-form>
        <bank-card-term-form v-if="currentProfile=='bank_card_terms'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></bank-card-term-form>
        <bank-form v-if="currentProfile=='banks'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></bank-form>
        <salesman-form v-if="currentProfile=='salesmen'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></salesman-form>
        <reason-form v-if="currentProfile=='reasons'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></reason-form>
        <reason-type-form v-if="currentProfile=='reason_types'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></reason-type-form>
        <payment-type-form v-if="currentProfile=='payment_types'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></payment-type-form>
        <pos-transaction-type-form v-if="currentProfile=='pos_transaction_types'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></pos-transaction-type-form>
        <rider-form v-if="currentProfile=='riders'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></rider-form>
        <table-management-form v-if="currentProfile=='table_templates'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></table-management-form>
        <sub-segment-form v-if="currentProfile=='pos_sub_segments'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></sub-segment-form>
        <tender-type-form v-if="currentProfile=='tender_types'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></tender-type-form>
        <collection-type-form v-if="currentProfile=='collection_types'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></collection-type-form>
        <menu-items-category-form v-if="currentProfile=='menu_items_categories'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></menu-items-category-form>
      </div>
    </a-drawer>

      <!-- history drawer -->
    <a-drawer title="" :width="800" placement="right" @close="onClose" :visible="historyVisible">
      <div>
        <h6 class="heading-small text-muted mb-4 text-truncate"> {{_.startCase(currentProfile)}} Action History</h6>
        <a-table v-if="currentProfile == 'table_templates'" :columns="historyColumns" :dataSource="historyData" size="small" />
        <a-table v-if="currentProfile == 'reasons'" :columns="posHistoryColumns" :dataSource="historyData" size="small" />
        <a-table v-if="currentProfile == 'reason_types'" :columns="posHistoryColumns" :dataSource="historyData" size="small" />
        <a-table v-if="currentProfile == 'banks'" :columns="posHistoryColumns" :dataSource="historyData" size="small" />
        <a-table v-if="currentProfile == 'bank_cards'" :columns="posHistoryColumns" :dataSource="historyData" size="small" />
        <a-table v-if="currentProfile == 'bank_card_terms'" :columns="posHistoryColumns" :dataSource="historyData" size="small" />
        <a-table v-if="currentProfile == 'payment_types'" :columns="posHistoryColumns" :dataSource="historyData" size="small" />
        <a-table v-if="currentProfile == 'pos_transaction_types'" :columns="posHistoryColumns" :dataSource="historyData" size="small" />
        <a-table v-if="currentProfile == 'riders'" :columns="posHistoryColumns" :dataSource="historyData" size="small" />
        <a-table v-if="currentProfile == 'pos_sub_segments'" :columns="posHistoryColumns" :dataSource="historyData" size="small" />
        <a-table v-if="currentProfile == 'tender_types'" :columns="posHistoryColumns" :dataSource="historyData" size="small" />
        <a-table v-if="currentProfile == 'collection_types'" :columns="posHistoryColumns" :dataSource="historyData" size="small" />
      </div>
    </a-drawer>

    <div class="table-responsive">
      <a-spin :spinning="loading">
        <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
          :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
          no-data-template="Empty" @vuetable:checkbox-toggled-all="log" @vuetable:checkbox-toggled="log"
          @vuetable:load-error="onLoadError" @vuetable:pagination-data="onPaginationData">

          <template slot="actions" slot-scope="props">
            <center>
              <div v-if="serverType == 'ho'" class="table-button-container">
                <button id="history" class="btn btn-primary btn-sm"
                  @click.prevent="showHistoryDrawer(props.rowData.id)">History</button>
                <button id="view" v-if="accessRights.includes('V')" class="btn btn-success btn-sm"
                  @click.prevent="showDrawer(props.rowData.id)">View</button>
                <!-- <button class="btn btn-success btn-sm" @click.prevent="showDrawer(props.rowData.id)">View</button>&nbsp;&nbsp; -->
                <button v-if="accessRights.includes('W')" class="btn btn-warning btn-sm"
                  @click.prevent="showDrawer(props.rowData.id)">Edit</button>
                <!-- <button class="btn btn-danger btn-sm" v-if="(currentProfile != 'payment_types')" @click.prevent="deleteRow(props.rowData.id)">Delete</button>&nbsp;&nbsp; -->
                <a-popconfirm v-if="accessRights.includes('D') && currentProfile != 'payment_types' && !props.rowData.is_system"
                  title="You are about to delete this record?" @confirm="deleteRow(props.rowData.id)" okText="Delete"
                  cancelText="Cancel">
                  <a class="btn btn-danger btn-sm text-white">Delete</a>
                </a-popconfirm>
              </div>
              <div v-else class="table-button-container">
                <button v-if="accessRights.includes('V')" class="btn btn-success btn-sm"
                  @click.prevent="showDrawer(props.rowData.id)">View</button>&nbsp;&nbsp;
              </div>
            </center>
          </template>

        </vuetable>
      </a-spin>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent'  : ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import {
  mapState,
  mapActions
} from 'vuex'
import BaggerForm from '../POS Profiles/BaggerForm.vue';
import BankForm from '../POS Profiles/BankForm.vue';
import BankCardForm from '../POS Profiles/BankCardForm.vue';
import BankCardTermForm from '../POS Profiles/BankCardTermForm.vue';
import SalesmanForm from '../POS Profiles/SalesmanForm.vue';
import ReasonForm from '../POS Profiles/ReasonForm.vue';
import ReasonTypeForm from '../POS Profiles/ReasonTypeForm.vue';
import PaymentTypeForm from '../POS Profiles/PaymentTypeForm.vue';
import DeviceForm from '../POS Profiles/DeviceForm.vue';
import PosTransactionTypeForm from '../POS Profiles/PosTransactionTypeForm.vue';
import RiderForm from '../POS Profiles/RiderForm.vue';
import TableManagementForm from '../POS Profiles/TableManagementForm.vue';
import SubSegmentForm from '../POS Profiles/SubSegmentForm.vue';
import TenderTypeForm from '../POS Profiles/TenderTypeForm.vue';
import CollectionTypeForm from '../POS Profiles/CollectionTypeForm.vue'
import MenuItemsCategoryForm from '../POS Profiles/MenuItemsCategoryForm.vue';

import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from '../../controllers/secureStorage';
import HTTPRequest from '../../controllers/httpRequest.js';
import draggable from "vuedraggable";
import moment from "moment";

import { formatStatus } from "../../utilities.js"

import ImportProfile from '../ImportProfile';
var component_x;


const pos_histories_column = [
  { title: "Action", dataIndex: "action", key: "action" },
  { title: "Field Name", dataIndex: "field_name", key: "field_name" },
  { title: "From", dataIndex: "old_value", key: "old_value" },
  { title: "To", dataIndex: "new_value", key: "new_value" },
  { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
];

export default {
  name: 'profiles-table',
  props: {
    type: {
      type: String
    },
    title: String
  },
  components: {
    Vuetable,
    VuetablePagination,
    BaggerForm,
    BankForm,
    BankCardForm,
    BankCardTermForm,
    ReasonForm,
    ReasonTypeForm,
    SalesmanForm,
    PaymentTypeForm,
    ImportProfile,
    DeviceForm,
    PosTransactionTypeForm,
    RiderForm,
    TableManagementForm,
    SubSegmentForm,
    TenderTypeForm,
    CollectionTypeForm,
    MenuItemsCategoryForm,
    draggable
  },
  computed: {
    ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters', 'serverType'])
  },
  data() {
    return {
      loading: false,
      locationOptions: [],
      viewMode: false,
      itemStatus: '',
      accessRights: [],
      errors: [],
      filterStatus: "",
      exportSelection: 0,
      profileAction: "",
      checkedFields: [],
      checkedItems: [],
      availableFields: [],
      errorMessage: null,
      successMessage: null,
      componentKey: 0,
      drawerVisible: false,
      visible: false,
      historyVisible: false,
      historyData: [],
      apiURL: "",
      posHistoryColumns: pos_histories_column,
      loading: false,
      pagination: false,
      historyColumns: [
        {
          title: "Action",
          dataIndex: "action",
        },
        {
          title: "Action By",
          dataIndex: "action_by",
        },
        {
          title: "Action At",
          dataIndex: "action_at",
          customRender: (value) => (
            <div> {moment(value).format("YYYY-MM-DD HH:mm:ss A")}</div>
          ),
        },
      ],
      fields: [],
      sortOrder: [{
        field: "name",
        direction: "asc"
      }],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
        }
      },
      css: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      draggableKey: 0,
      fixed_columns: [ 'id', 
                      'code', 
                      'name', 
                      'pos_transaction_type_id', 
                      'pos_transaction_type_code', 
                      'pos_transaction_type_name',
                      'all_payments',
                      'allowed_payment_types_id', 
                      'remark'] //fixed fields on export file for sub_segment profile
    }
  },
  watch: {
    currentApiURL: function () {
      this.$refs.vuetable.resetData()
      this.apiURL = this.currentApiURL
    },
    parameters: function () {
      this.apiURL = this.currentApiURL
      this.apiURL = this.apiURL + this.parameters
      this.$refs.vuetable.selectedTo = []
      this.checkedItems = []
    },
    currentProfile: function () {
      this.initializeTable()
    },
    checkedFields: function () {
      if (!this.checkedFields.length) {
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.',
          placement: 'bottomRight'
        })
        this.checkedFields = ["name", "status"]
        this.fields = ["__checkbox", "name", { name: "status", callback: (value) => formatStatus(value)}, "__slot:actions"]
        this.reinitializeFields();
      }
    }
  },
  methods: {
    ...mapActions(['updateProfileId']),
    closeDrawer() {
      this.onClose()
    },
    refreshPage() {
      this.onClose()
      this.$refs.vuetable.refresh()
      this.successMessage = "Successful Operation"
      this.errorMessage = null
    },
    async showHistoryDrawer(id) {
      // if (this.currentProfile == "table_templates") {
      //   if (event.target.id == "history") {
      //     var tableTemplateHistory = await HTTPRequest.getRequest(this.endPoint + "table_template_action_histories/" + id + "?field_name=profile_id", null);
      //     this.historyData = tableTemplateHistory
      //   }
      // }
      switch (this.currentProfile) {
        case "table_templates":
          if (event.target.id == "history") {
              let tableTemplateHistory = await HTTPRequest.getRequest(this.endPoint + "table_template_action_histories/" + id + "?field_name=profile_id",null);
              this.historyData = tableTemplateHistory;
          }
          break;
        case "reasons":
          if (event.target.id == "history") {
              let reasonHistorydata = await HTTPRequest.getRequest(this.endPoint + "reason_update_histories?reason_id=" + id, null, null);
              this.historyData = reasonHistorydata;
          }
          break;
        case "reason_types":
          if (event.target.id == "history") {
              let reasonTypeHistoryData = await HTTPRequest.getRequest(this.endPoint + "reason_type_update_histories?reason_type_id=" + id, null, null);
              this.historyData = reasonTypeHistoryData;
          }
          break;
        case "banks":
          if (event.target.id == "history") {
              let bankHistoryData = await HTTPRequest.getRequest(this.endPoint + "bank_update_histories?bank_id=" + id, null, null);
              this.historyData = bankHistoryData;
          }
          break;
        case "bank_cards":
          if (event.target.id == "history") {
              let bankCardHistoryData = await HTTPRequest.getRequest(this.endPoint + "bank_card_update_histories?bank_card_id=" + id, null, null);
              this.historyData = bankCardHistoryData;
          }
          break;
        case "bank_card_terms":
          if (event.target.id == "history") {
              let bankCardTermHistoryData = await HTTPRequest.getRequest(this.endPoint + "bank_card_term_update_histories?bank_card_term_id=" + id, null, null);
              this.historyData = bankCardTermHistoryData;
          }
          break;
        case "payment_types":
          if (event.target.id == "history") {
              let paymentTypeHistoryData = await HTTPRequest.getRequest(this.endPoint + "payment_type_update_histories?payment_type_id=" + id, null, null);
              this.historyData = paymentTypeHistoryData;
          }
          break;
        case "pos_transaction_types":
          if (event.target.id == "history") {
              let posTransactionTypeHistoryData = await HTTPRequest.getRequest(this.endPoint + "pos_transaction_type_update_histories?pos_transaction_type_id=" + id, null, null);
              this.historyData = posTransactionTypeHistoryData;
          }
          break;
        case "riders":
          if (event.target.id == "history") {
              let riderHistoryData = await HTTPRequest.getRequest(this.endPoint + "rider_update_histories?rider_id=" + id, null, null);
              this.historyData = riderHistoryData;
          }
          break;
        case "pos_sub_segments":
          if (event.target.id == "history") {
              let posSubSegmentHistoryData = await HTTPRequest.getRequest(this.endPoint + "pos_sub_segment_update_histories?pos_sub_segment_id=" + id, null, null);
              this.historyData = posSubSegmentHistoryData;
          }
          break;
        case "tender_types":
          if (event.target.id == "history") {
              let tenderTypeHistoryData = await HTTPRequest.getRequest(this.endPoint + "tender_type_update_histories?tender_type_id=" + id, null, null);
              this.historyData = tenderTypeHistoryData;
          }
          break;
        case "collection_types":
          if (event.target.id == "history") {
              let collectionTypeHistoryData = await HTTPRequest.getRequest(this.endPoint + "collection_type_update_histories?collection_type_id=" + id, null, null);
              this.historyData = collectionTypeHistoryData;
          }
          break;
        default:
          break;
      }
      this.historyVisible = true
    },
    showDrawer(id) {

      if (event.target.id == "view") {
        this.viewMode = true
      } else {
        this.viewMode = false
      }
      this.componentKey++
      this.updateProfileId(id)
      this.visible = true
    },
    async showActionDrawer(action) {
      if (action == "customize_list") {
        var response = await HTTPRequest.getRequest(
          this.endPoint + this.currentProfile + "/get_viewable_fields",
          null
        );
        
        let unsortedFields = response["fields"];
        let sortedFields = this.checkedFields.slice();

        unsortedFields.forEach(fieldName => {
          if (!this.checkedFields.includes(fieldName))
            sortedFields.push(fieldName)
        });

        this.availableFields = sortedFields;

      }
      this.profileAction = action;
      this.drawerVisible = true;
    },
    onClose() {
      this.errors = [];
      this.drawerVisible = false
      this.historyVisible = false;
      this.visible = false
      this.componentKey++
    },
    log(checked, value) {
      this.checkedItems = this.$refs.vuetable.selectedTo
      if (this.checkedItems.length == 1) {
        this.itemStatus = value.status
        // console.log(this.itemStatus)
      } else {
        this.itemStatus = ''
      }
    },
    onCheckField(fieldName) {
      if (this.checkedFields.includes(fieldName)) {
        var indexValue = this.checkedFields.indexOf(fieldName);
        if (indexValue > -1) {
          this.checkedFields.splice(indexValue, 1);
        }
      } else {
        this.checkedFields.push(fieldName);
      }

      // save custom list to local storage
      const localStoreName = this.currentProfile + "POSProfileCheckedFields"
      localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields))
      this.$refs.vuetable.normalizeFields();
    },
    onCheckAllField() {
      if (this.checkedFields.length == this.availableFields.length) {
        this.checkedFields = []
        this.fields = ['__checkbox', '__slot:actions']
      } else {
        this.checkedFields = this.availableFields.slice()
        this.fields = ['__checkbox']
        this.fields = this.fields.concat(this.checkedFields)
        this.fields.push("__slot:actions")
      }
       // save custom list to local storage
      const localStoreName = this.currentProfile + "POSProfileCheckedFields"
      localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields))
      this.$refs.vuetable.normalizeFields();
    },
    reinitializeFields() {
      this.$nextTick(() => {
        this.$refs.vuetable.normalizeFields();
      });
    },
    async massupdate(field_name, value) {
      var field_update = {}
      field_update[field_name] = value
      var payload = {
        ids: this.checkedItems,
        field_update: field_update
      }
      var response = await HTTPRequest.postRequest(this.endPoint + this.currentProfile + "/mass_update", null,
        payload)
      if (response["message"] == "OK" || response["message"] == "Ok" ) {
        this.successMessage = "Update successful!"
        this.$refs.vuetable.refresh()
        this.checkedItems = []
        this.$refs.vuetable.selectedTo = []
      } else {
        this.errorMessage = "Update failed!"
      }
    },
    async onPaginationData(paginationData) {
      // await axios({
      //     method: 'PUT',
      //     url: this.endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
      //     headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
      // })
      this.$refs.pagination.setPaginationData(paginationData);
    },
    async onLoadError(error) {
      // request for new token or reauthenticate
      if (error.response.status == 401) {
        var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
        if (auth_response["status"] == "Ok") {
          this.$router.go();
        } else {
          alert("Cannot get access token. Please login again.")
          this.$router.push("/")
        }
      } else {
        if (error.response.data.error == "Session expired") {
          alert("Session is already expired. Please login again.")
          document.getElementById("logoutButton").click()
        }
      }
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    deleteRow(id) {
      axios({
        method: 'delete',
        url: this.endPoint + this.currentProfile + '/' + id,
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
        },
      })
        .then(function () {
          component_x.successMessage = "Successfully deleted record"
          component_x.$refs.vuetable.refresh()
        })
        .catch(function () {
          alert("Invalid Credentials")
        });
    },
    download() { // Must update other Profile Tables download function to be aligned
      var payload = {}
      var additional_parameters = ""
      var baseUrl = this.currentApiURL + "/download?file_type=csv"
      if (this.exportSelection == "0") {
        // All
        payload["type"] = "all"
      } else if (this.exportSelection == "1") {
        // Current Page
        var ids = this.$refs.vuetable.tableData.map(({ id }) => id)
        payload["type"] = "current_page";
        if (ids == 0) {
          this.errors.push('No Record(s)');
          return;
        } else {
          payload["ids"] = ids
        }

      } else if (this.exportSelection == "2") {
        // Selected
        payload["type"] = "selected"
        if (this.checkedItems == 0) {
          this.errors.push('No Selected Record(s)');
          return;
        } else {
          payload["ids"] = this.checkedItems
        }
      } else {
        // Filtered
        payload["type"] = "filtered"
        additional_parameters = this.parameters
      }

      var exportFields = [...this.fields]
      var cbIndex = exportFields.indexOf("__checkbox");
      if (cbIndex > -1) exportFields.splice(cbIndex, 1)
      var actionIndex = exportFields.indexOf("__slot:actions");
      if (actionIndex > -1) exportFields.splice(actionIndex, 1)
      
      for (const [index, field] of exportFields.entries()) {
          if (typeof field == "object")
            exportFields[index] = field.name
      }

      let subSegmentExportFields = []
      if (this.currentProfile == 'pos_sub_segments'){
        subSegmentExportFields = [...this.fixed_columns, ...exportFields]
        let uniqueFields = [];
        subSegmentExportFields.forEach((element) => {
            if (!uniqueFields.includes(element)) {
                uniqueFields.push(element);
            }
        });
        payload["fields"] = uniqueFields
      }else{
        payload["fields"] = exportFields
      }

      additional_parameters = additional_parameters.replace('?', '&');

      axios({
        url: baseUrl + additional_parameters,
        method: 'POST',
        responseType: 'blob', // important
        headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File" },
        data: payload,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.csv');
        document.body.appendChild(link);
        link.click();
        this.onClose();
        this.filterStatus = null
        this.successMessage = "Download successful"
      });
    },
    displayMessage(message) {
      if (message["error"] != undefined) {
        this.onClose()
        this.errorMessage = message["error"]
        this.successMessage = null
      }
    },
    removeMessage(type) {
      if (type == 'error')
        this.errorMessage = null
      else
        this.successMessage = null
    },
    updateTableList() {
      var reference_array = this.availableFields;
      var array = this.checkedFields;
      if (array.length) {
        array.sort(function (a, b) {
          return reference_array.indexOf(a) - reference_array.indexOf(b);
        });
        this.checkedFields = array;
      } else {
        this.checkedFields = ["name", "status"];
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.'
        })
      }

      let localStoreName = this.currentProfile + "POSProfileCheckedFields"
      localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields));

      this.fields = this.checkedFields.map(column => {
        if (column === "status") {
          return {
            name: "status",
            callback: (value) => formatStatus(value)
          }
        } else if (column === "sites") {
          return {
            name: "sites",
            callback: value => value.length ? value.join(", ") : "All Sites"
          }
        } else if (column === "site_name") {
          return {
            name: "site_name",
            title: "site name"
          }
        } else if (column === "tender_type") {
          return {
            name: "tender_type",
            title: "tender type"
          }
        } else return column
      })
      this.fields.push("__slot:actions");
      this.fields.unshift("__checkbox")

      this.reinitializeFields();
      this.onClose();
    }
  },
  beforeMount: async function () {
    const posProfileCustomList = localStorage.getItem(this.currentProfile + "POSProfileCheckedFields")
    if (posProfileCustomList != undefined && posProfileCustomList != null && posProfileCustomList != "[]") {
      this.checkedFields = JSON.parse(posProfileCustomList)
      this.fields = this.checkedFields.map(column => {
        if (column === "status") {
          return {
            name: "status",
            callback: (value) => formatStatus(value)
          }
        } else if (column === "sites") {
          return {
            name: "sites",
            callback: value => value.length ? value.join(", ") : "All Sites"
          }
        } else if (column === "site_name") {
          return {
            name: "site_name",
            title: "site name"
          }
        } else if (column === "tender_type") {
          return {
            name: "tender_type",
            title: "tender type"
          }
        } else return column
      })
      this.fields.push("__slot:actions")
      this.fields.unshift("__checkbox")
      this.initLoad++
    } else {
      if (this.currentProfile == 'table_templates'){
        this.checkedFields = ["name", "status", "site_name"];
        this.fields = [
          "__checkbox",
          "name",
          {
            name: "status",
            callback: (value) => formatStatus(value)
          },
          {name: "site_name", title: "site name"},
          "__slot:actions"
        ];
      }else if (this.currentProfile == 'payment_types'){
        this.checkedFields = ["name", "status", "tender_type"];
        this.fields = [
          "__checkbox",
          "name",
          {
            name: "status",
            callback: (value) => formatStatus(value)
          },
          {name: "tender_type", title: "tender type"},
          // {
          //   name: "site_id",
          //   callback: (value) => formatSiteIdOnTable(value)
          // },
          "__slot:actions"
        ];
      } else {
        this.checkedFields = ["name", "status"];
        this.fields = [
          "__checkbox",
          "name",
          {
            name: "status",
            callback: (value) => formatStatus(value)
          },
          "__slot:actions"
        ];
      }
      
      localStorage.removeItem(this.currentProfile + "POSProfileCheckedFields")
    }
  },
  mounted: async function () {
    // if(this.serveType == 'ho'){
    //   this.fields =  ['__checkbox', "id", "name", '__slot:actions']
    //   this.$refs.vuetable.normalizeFields()
    // }else{
    //   this.fields =  ["id", "name", '__slot:actions']
    //   this.$refs.vuetable.normalizeFields()
    // }
    this.loading = true
    component_x = this;
    this.accessRights = this.$attrs.accessRights
    this.apiURL = this.currentApiURL

    if (this.currentProfile == "devices") {
      this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view?full=1', null)
    }
    this.loading = false

  }
}
</script>

<style>
</style>
